<template>
  <div class="relative">
    <div class="pt-24 pb-8 lg:px-20 md:px-20 px-5">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16">Resources</el-breadcrumb-item>
        <el-breadcrumb-item class="fsize16">Podcast</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- <modal
      :show.sync="editModal"
      size="xl"
      centered
      modal-content-classes="cust-modal-ht"
      hide-footer
      scrollable
      hide-header
      class=" overflow-y-hidden"
    >
      <div class="text-black p-8">
        <div class="">
          <div class="flex justify-between items-center  pb-4">
            <p class="text-2xl font-semibold">ISBA Test</p>
            <img
              src="../../../assets/images/cross.png"
              class="h-8 w-8 cursor-pointer"
              alt="cross"
              @click="editModal = false"
            />
          </div>
          <div class="pt-4" v-for="(item, index) in 4" :key="index">
            <p class="clr777 font-normal text-lg">Question 1</p>
            <p class="font-medium text-2xl text-black pt-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam?
            </p>

            <b-form-group v-slot="{ ariaDescribedby }" class="pt-6">
              <div class="flex items-center">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="A"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black">Option A</span>
                </b-form-radio>
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="B"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option B</span
                  ></b-form-radio
                >
              </div>
              <div class="flex pt-3">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="C"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option C</span
                  ></b-form-radio
                >
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="D"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option D</span
                  ></b-form-radio
                >
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
    </modal> -->
    <!-- v-for="(item, index) in 6" :key="index" -->

    <!-- <div class="absolute bg-design1 mob-hidden">
        <img
          src="../../../../assets/images/bg-des/bgd1.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design2 mob-hidden">
        <img
          src="../../../../assets/images/bg-des/bgd2.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div class="absolute bg-design3 mob-hidden">
        <img
          src="../../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="flex justify-end relative h-95per">
        <img
          src="../../../../assets/images/cp-bg.png"
          alt="cp bg"
          class="h-640px bg-white"
        />
      </div> -->
    <div class="lg:px-20 md:px-20 px-5 pb-10 w-full">
      <!-- <img
          src="../../../../assets/images/cp-bg.png"
          alt="cp bg"
          class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
        /> -->
      <!-- ///////////////////////// -->
      <div class="lg:flex md:flex items-center gap-9">
        <div class="w-1/2 sm-wfull">
          <p class="clr4F0A4B font-semibold">Watch New Podcasts</p>

          <p class="py-1">{{ allEpisode.podcastId.name }}</p>
          <p
            class="fsize32 md-fsize28 sm-fsize20 font-semibold clr-black lg:leading-10 md:leading-10 leading-8"
          >
            {{ allEpisode.title }}
          </p>
          <p
            class="py-2 sm-fsize14 text-justify"
            v-html="allEpisode.description"
          ></p>
          <p class="font-semibold pt-2 sm-fsize14">
            {{
              new Date(allEpisode.createdAt).toLocaleDateString(undefined, {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            }}
          </p>
          <button
            class="flex gap-2 bg4F0A4B clr-fff p-2 rounded-full px-6 py-2 mt-4 sm-fsize14"
            @click="handleRedirect(allEpisode.link)"
          >
            Play
            <feather-icon
              icon="PlayIcon"
              class="clr-fff sm-fsize14"
              svgClasses="lg:w-4 lg:h-4 md:w-4 md:h-4 w-3 h-3 mt-1"
            ></feather-icon>
          </button>
        </div>
        <div class="w-1/2 sm-wfull">
          <!-- <iframe
          class="scrnht-250 w-full rounded-xl"
          :src="handleFrame(episodeDetails.video_url)"
          frameborder="1"
        ></iframe> -->
          <img
            class="w-full h-400 sm-h-250px rounded-xl object-contain"
            :src="`${$imageURL}/${allEpisode.image}`"
            alt="img"
          />
        </div>
      </div>

      <!-- ///////////////////////// -->

      <!-- <div class="lg:w-1/2 md:w-1/2 w-full">
          <div class="">
            <p
              class="font-semibold fsize48 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-5/6"
            >
              Podcast
            </p>
            <p
              class="fsize25 md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
            >
              Stories help us connect. Our series are specially designed for
              caregivers to share their personal journey and experiences and
              inspire others to engage.
            </p>
          </div>
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-5">
          <img
            src="https://nexuscluster.blob.core.windows.net/server01/caregiversaathi/Cg-img/FFC%20Podcast%203.jpg"
            class="m-auto custborderradius block lg:hidden md:hidden"
            alt=""
          />
          <img
            src="https://nexuscluster.blob.core.windows.net/server01/caregiversaathi/Cg-img/FFC%20Podcast%203.jpg"
            class="m-auto custborderradius lg:block md:block hidden"
            alt=""
          />
        </div> -->
      <!-- ///// -->
      <!-- <div class="w-1/2 relative">
            <img
              src="../../../../assets/images/cp-bg.png"
              alt="cp bg"
              class="w-full relative h-screen"
            />
            <img
              src="../../../../assets/images/swiper-img/swpr-insi-pod.svg"
              class="w-full absolute top6rem  h-screen"
              alt=""
            />
          </div> -->
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
        },
      },
      editModal: false,
      allEpisode: {},
    };
  },

  methods: {
    handleRedirect(embedLink) {
      if (embedLink) {
        const directLink = embedLink.replace("/embed/", "/");
        window.open(directLink, "_blank");
      }
    },
    async dataLoad() {
      let payload = {
        isBanner: true,
      };
      let { data } = await this.$store.dispatch(
        "podcast/getall_episode",
        payload
      );
      this.allEpisode = data.result[0];
    },
    // async handleOpen(url, toRecent = false, id = "") {
    //   if (toRecent) {
    //     let payload = {
    //       episodeId: id,
    //     };
    //     try {
    //       await this.$store.dispatch("podcast/add_history", payload);
    //       this.dataLoad();
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   }
    //   window.open(url, "_blank");
    // },
    embedLink(link) {
      if (link) {
        if (link.includes("embed")) {
          return link;
        }
        return link.replace(
          "/pod/show/caregiver-saathi/",
          "/pod/show/caregiver-saathi/embed/"
        );
      }
      return "";
    },
  },
  computed: {
    ...mapState("podcast", {
      getAllEpisode: "getAllEpisode",
      getEpisode: "getEpisode",
    }),
    ...mapState("auth", { user: "user" }),
  },
  mounted() {
    this.dataLoad();
    // console.log("podacts", this.getAllEpisode);
  },
};
</script>
